import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import FieldRenderer from "features/maintenance/components/FieldRenderer";

function AgencyInformation({
    resource,
    form,
    setForm,
    showValidation,
    items,
    errors = []
}) {
    const fields = resource.fields;
    const agencyName = fields[0];
    const address = fields[1];
    const email = fields[2];
    const website = fields[3];
    const tin = fields[4];
    const sss = fields[5];
    const gsis = fields[6];
    const philhealth = fields[7];

    return (
        <GridContainer direction="column">
            <GridItem>
                <FieldRenderer
                    key={agencyName.name}
                    field={agencyName}
                    form={form}
                    setForm={setForm}
                    errors={errors}
                    showValidation={showValidation}
                />
            </GridItem>
            <GridItem>
                <FieldRenderer
                    key={address.name}
                    field={address}
                    form={form}
                    setForm={setForm}
                    errors={errors}
                    showValidation={showValidation}
                />
            </GridItem>
            <GridItem xs>
                <GridContainer noWrap>
                    <GridItem xs={6}>
                        <FieldRenderer
                            key={email.name}
                            field={email}
                            form={form}
                            setForm={setForm}
                            errors={errors}
                            showValidation={showValidation}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <FieldRenderer
                            key={website.name}
                            field={website}
                            form={form}
                            setForm={setForm}
                            errors={errors}
                            showValidation={showValidation}
                        />
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem>
                <GridContainer>
                    <GridItem xs={6}>
                        <FieldRenderer
                            key={tin.name}
                            field={tin}
                            form={form}
                            setForm={setForm}
                            errors={errors}
                            showValidation={showValidation}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <FieldRenderer
                            key={sss.name}
                            field={sss}
                            form={form}
                            setForm={setForm}
                            errors={errors}
                            showValidation={showValidation}
                        />
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem>
                <GridContainer>
                    <GridItem xs={6}>
                        <FieldRenderer
                            key={gsis.name}
                            field={gsis}
                            form={form}
                            setForm={setForm}
                            errors={errors}
                            showValidation={showValidation}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <FieldRenderer
                            key={philhealth.name}
                            field={philhealth}
                            form={form}
                            setForm={setForm}
                            errors={errors}
                            showValidation={showValidation}
                        />
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
}

export default AgencyInformation;
